import { create } from 'zustand';

const state = { isLoadingPage: false };

export const useLoader = create((set) => ({
    ...state,
    onChangeLoader: (newState) => set((state) => ({ ...state, ...newState })),
    onResetLoader: () => set(() => ({ ...state })),
}));
